import { RuleSelectionPopover } from '@carboncopyco/editor-ui';
import {
  LinkIcon,
  PhotoSquareOutlineIcon,
  TextOutlineIcon,
} from '@carboncopyco/icons';
import { IFindAndReplaceRuleType } from '@carboncopyco/types';
import type { PopoverProps } from '@carboncopyco/ui';
import { useMemo } from 'react';

type RuleOption =
  | IFindAndReplaceRuleType.replaceText
  | IFindAndReplaceRuleType.replaceImage
  | IFindAndReplaceRuleType.replaceLink;

export interface RuleSelectionPopoverProps
  extends Pick<PopoverProps, 'triggerElement' | 'open' | 'onOpenChange'> {
  onSelect: (ruleType: RuleOption) => void;
}

export const FindAndReplaceRuleSelectionPopover = ({
  triggerElement,
  open,
  onOpenChange,
  onSelect,
}: RuleSelectionPopoverProps) => {
  const items = useMemo(
    () => [
      {
        value: IFindAndReplaceRuleType.replaceText,
        icon: <TextOutlineIcon />,
        label: 'Text',
      },
      {
        value: IFindAndReplaceRuleType.replaceImage,
        icon: <PhotoSquareOutlineIcon />,
        label: 'Images',
      },
      {
        value: IFindAndReplaceRuleType.replaceLink,
        icon: <LinkIcon />,
        label: 'Link',
      },
    ],
    []
  );

  return (
    <RuleSelectionPopover
      open={open}
      onOpenChange={onOpenChange}
      triggerElement={triggerElement}
      options={items}
      onSelect={onSelect}
    />
  );
};
